module.exports = __webpack_public_path__ + "img/phone_hover.9c68d6e.svg";